import ButtonContent from "components/common/Button/ButtonContent";
import * as React from "react";
import { HTMLProps, ReactNode } from "react";
import styled from "styled-components";
import theme from "themes/simple-theme";

interface IProps extends HTMLProps<HTMLButtonElement> {
  primary?: boolean;
  secondary?: boolean;
  tertiary?: boolean;
  active?: boolean;
  reset?: boolean;
  link?: boolean;
  wide?: boolean;
  wider?: boolean;
  fullWidth?: boolean;
  center?: boolean;
  disabled?: boolean;
  loading?: boolean;
  completed?: boolean;
  completedText?: string;
  children: ReactNode;
}

const Button = styled((props: IProps) => (
  <button {...props}>
    <ButtonContent
      primary={props.primary}
      completedText={props.completedText}
      loading={props.loading}
      completed={props.completed}
      children={props.children}
    />
  </button>
))`
  cursor: pointer;
  padding: 1.85rem 2.4rem;
  border: none;
  text-transform: uppercase;
  letter-spacing: 0.1rem;
  font-size: ${theme.fontSize.m};
  font-family: ${theme.fontFamily.bold};
  border-radius: ${theme.global.radius};
  min-width: 150px;
  &:focus{
    outline:0;
  }

  ${({ primary }: IProps) =>
    primary
      ? `
    background-color: ${theme.color.primary};
    color: ${theme.color.white};
    `
      : ``}

  ${({ secondary }: IProps) =>
    secondary
      ? `
    background-color: ${theme.color.secondary};
    color: ${theme.color.primary};
    `
      : ``}

  ${({ tertiary }: IProps) =>
    tertiary
      ? `
    background-color: ${theme.color.tertiary};
    color: ${theme.color.primary};
    `
      : ``}

  ${({ active }: IProps) =>
    active
      ? `
    background-color: ${theme.color.tertiary};
    color: ${theme.color.white};
    font-size: ${theme.fontSize.s};
    padding: 10px 15px;
    `
      : ``}

  ${({ reset }: IProps) =>
    reset
      ? `
    font-family: ${theme.fontFamily.black};
    font-size: ${theme.fontSize.s};
    color: ${theme.color.primary};
    background-color: transparent;
      `
      : ``}
  
    ${({ link }: IProps) =>
      link
        ? `
    font-family: ${theme.fontFamily.black};
    font-size: ${theme.fontSize.s};
    color: ${theme.color.primary};
    background-color: transparent;
    text-decoration: underline;
      `
        : ``}

 

  ${({ wide }: IProps) => (wide ? `width: 180px;` : ``)}

  ${({ wider }: IProps) => (wider ? `width: 220px;` : ``)}

  ${({ fullWidth }: IProps) => (fullWidth ? `width: 100%;` : ``)}

  ${({ center }: IProps) => (center ? `text-align: center;` : ``)}
  
${({ loading, tertiary, secondary }: IProps) =>
  loading && (tertiary || secondary) ? `color: inherit;` : ``}
  
  ${({ loading, primary }: IProps) =>
    loading && primary ? `color: inherit;` : ``}
  

  ${({ disabled }: IProps) =>
    disabled
      ? `
      pointer-events: none;
      background-color: ${theme.color.gray.light};
      color: ${theme.color.gray.medium};
      `
      : ``}
   ${({ link, disabled }: IProps) =>
     link && disabled ? `background-color: transparent !important;` : ``}
  
`;

export default Button;



// WEBPACK FOOTER //
// ./src/components/common/Button/Button.tsx